import { DS_HEIGHT } from '@calm/evexia-design-tokens';

export const PARTNER_LOGO_HEIGHT = DS_HEIGHT.AVATAR_LARGE;
export const PARTNER_LOGO_HEIGHT_SMALL = DS_HEIGHT.AVATAR_MEDIUM;
export const PARTNER_LOGO_WIDTH = 248;
